<!-- 首席服务员收集问题和解决问题排名 -->
<template>
    <div class='wrapper box_v' ref="cheif_right2">
        <div class="title1">各学校生源数统计</div>
        <div class="tabbox box box_center">
          <div class="tablist box box_center ac" :style="selectIndex==1?'color: #0EBFFF':'color: #00A2DD'" @click="tabclick(1)"><span>幼升小</span><span v-if="selectIndex==1?true:false"></span></div>
          <div class="tablist box box_center ac" :style="selectIndex==2?'color: #0EBFFF':'color: #00A2DD'" @click="tabclick(2)"><span>五升六</span><span v-if="selectIndex==2?true:false"></span></div>
          <div class="tablist box box_center ac" :style="selectIndex==3?'color: #0EBFFF':'color: #00A2DD'" @click="tabclick(3)"><span>小升初</span><span v-if="selectIndex==3?true:false"></span></div>
        </div>
        <div class="conlistbox box_v">
          <div class="conlist box box_between ac" v-for="(item,index) in conlist">
            <div class="conlistleft box ac">
              <span>({{index+1}})</span><span>濮阳第一小学</span>
            </div>
            <div class="conlistright">
              <span>222 </span><span>人</span>
            </div>
          </div>


        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {scroll},
    data() {
    //这里存放数据
        return {
            selectIndex:1,
            conlist:[{},{},{},{}]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      tabclick(index){
        this.selectIndex=index
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper{
    background-image: url('../../../../assets/images/monitorpy/bottom.png');
    background-size: 100% 100%;
}
.title1{
       font-size: 18px;
       font-weight: bold;
       color: #FFFFFF;
       margin-left: 40px;
       margin-top: 20px
    }
.tabbox{width:100%;height:32px;}
.tablist{width: 50px;height:32px;position: relative;color: #00A2DD;font-size: 14px;font-weight: bold;text-align: center;}
.activetab{color: #0EBFFF;}
.tablist span:nth-child(2){width: 40px;height: 3px;background: #34B5FF;border-radius: 2px;position: absolute;bottom: 0;margin-left:2.5px;}
.conlistbox{width:98%;margin: 0 auto;margin-top: 10px;}
.conlist{width: 100%;margin-bottom: 10px;height: 36px;}
.conlistleft{line-height: 36px;font-size: 14px;font-weight: bold;color: #31E8FF;}
.conlistleft span:nth-child(1){margin-left: 16px;}
.conlistleft span:nth-child(2){margin-left: 10px;}

.conlist:nth-child(odd){background:rgba(53, 76, 136, 0.5);}
.conlist:nth-child(even){background: rgba(40, 56, 99, 0.5);}
.conlistright{height: 36px;line-height: 36px;}
.conlistright span:nth-child(1){background: linear-gradient(0deg, #F5A418 0%, #FF502D 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;font-weight: bold;
font-style: italic;font-size: 18px;color: #0EBFFF;}
.conlistright span:nth-child(2){background: linear-gradient(0deg, #F5A418 0%, #FF502D 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;font-weight: bold;
font-style: italic;font-size: 12px;color: #0EBFFF;margin-right: 15px;}
</style>
